var lists_default = {
  "fontElementMap": "Ra4WQ",
  "orderedlist": "IKnez",
  "bulletedlist": "hbjgS",
  "listItem": "xttFF"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
